import styled from "@emotion/styled";

import { Card as MuiCard, Grid, CardContent } from "@mui/material";
import { spacing } from "@mui/system";

import OlogaPageHeader from "../../components/misc/OlogaPageHeader";
import AssessmentForm from "./AssessmentForm";

const Card = styled(MuiCard)(spacing);

function AssessmentCreate() {
  return (
    <>
      <OlogaPageHeader
        title="Add Assessment"
        items={[{ label: "Assessments", url: "/assessments/search" }]}
      />

      <Grid container>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <AssessmentForm
                assessment={{
                  id: 0,
                  name: "",
                }}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}

export default AssessmentCreate;
